import { render, staticRenderFns } from "./AppointmentLayout.vue?vue&type=template&id=4a138df7&scoped=true"
import script from "./AppointmentLayout.vue?vue&type=script&lang=js"
export * from "./AppointmentLayout.vue?vue&type=script&lang=js"
import style0 from "./AppointmentLayout.vue?vue&type=style&index=0&id=4a138df7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a138df7",
  null
  
)

export default component.exports